import { isObject } from "utils/utils"

export function processError<T>(error: unknown, fallbackData: T): Error {
    if (isObject(error) && error instanceof ErrorWithFallback) {
        error.fallbackData = fallbackData || {}
        return error
    }
    if (typeof error === "string") {
        return new ErrorWithFallback<T>(error, fallbackData)
    }
    return new ErrorWithFallback<T>("неизвестная ошибка", fallbackData)
}

export class ErrorWithFallback<T> extends Error {
    fallbackData: T
    constructor(message: string, fallbackData: T) {
        super(message)
        this.fallbackData = fallbackData
    }
}

export class CallFailedError<T> extends ErrorWithFallback<T> {
    code: number
    constructor(message: string, code: number, fallbackData: T) {
        super(message, fallbackData)
        this.name = this.constructor.name
        this.code = code
    }
}

export class RequestLoginOneTimeKeyError<T> extends ErrorWithFallback<T> {
    constructor(fallbackData: T) {
        super("LoginCard to voximplant failed", fallbackData)
        this.name = this.constructor.name
    }
}

export class LoginError<T> extends ErrorWithFallback<T> {
    code: number | undefined
    constructor(code: number | undefined, fallbackData: T) {
        super("LoginCard to voximplant failed", fallbackData)
        this.name = this.constructor.name
        this.code = code
    }
}
